import Image from "next/image"
import {useTranslation} from "next-i18next"
import React, {FC, useContext, useMemo} from "react"
import NavLink from "../reusable/components/NavLink/NavLink"
import Typography from "../reusable/Typography/Typography"
import BookAppointmentButton from "../reusable/ModalButtons/BookAppointmentButton"
import AskAQuestionModalButton from "../reusable/ModalButtons/AskAQuestionModalButton"
import {filterUrl} from "../filter/FilterUrl"
import urlParams from "../../utility/UrlParams"
import DataContext from "../../context/DataContext"
import {getMenuTitles} from "../../utility/Helper"

type Props = {
	links?:{id: number, label:string, href:string}[]
}

const OrderPriceWarning:FC<Props> = ({links}) => {
	const {t} = useTranslation("checkout")
	const {collections, brands} = useContext(DataContext)

	const brandsForFooter = brands?.filter(({fields}) => fields?.addToFooter)
	const menuTitles = useMemo(() => getMenuTitles(collections, brandsForFooter), [collections, brandsForFooter])
	return (
		<div className="bg-light px-4 py-5 container-fluid my-4">
			<div className="d-flex align-items-center mb-3">
				{process.env.NEXT_PUBLIC_STOREFRONT !== "mysofaplan" && <span className="d-inline-block rounded-circle bg-primary p-2 d-inline-flex me-2">
					<Image src={"/assets/icons/bike-nobg.svg"}
						height={22}
						width={22}/>
				</span>}
				<Typography variant="heading3"
					semanticTag="span">{t("orderPriceWarning-Header")}</Typography>
			</div>

			<Typography className="text-start mb-4"
				variant="bodyLg"
				semanticTag="div">{t("orderPriceWarning-para")}</Typography>
			<div className="row">

				<ul className="list-unstyled col-12 col-md-6 justify-content-start mb-0">
					{menuTitles.mobile[0].items?.slice(0, 6).map(({name, href}, id) => <NavLink className="mb-3 col-12 text-start"
						borderBottom
						key={id}
						href={filterUrl({[urlParams.categories]: href.slice(1)}, urlParams.categories, href.slice(1))}
						label={t(name)}/>)}
				</ul>
				<div className="col-12 col-md-6">
					<BookAppointmentButton render={onClick => <NavLink btn
						onClick={onClick}
						className="mb-3 col-12 text-start"
						borderBottom
						label={t("orderPriceWarning-link-6")}/>}/>
					<AskAQuestionModalButton label={t("orderPriceWarning-link-7")}/>
				</div>
			</div>
		</div>
	)
}

export default OrderPriceWarning

OrderPriceWarning.defaultProps = {
	links: [
		{id: 1, label: "orderPriceWarning-link-1", href: "trekking-e-bike"},
		{id: 2, label: "orderPriceWarning-link-2", href: "mountain-e-bike"},
		{id: 3, label: "orderPriceWarning-link-3", href: "e-urban"},
		// {id: 4, label: "orderPriceWarning-link-4", href: "damen"}, // TODO: CHECK if damen ebikes even exist because it always return empty result
		{id: 5, label: "orderPriceWarning-link-5", href: "herren"}
	]

}
